import React, { Component } from "react";
import { Grid } from "@mui/material";
import GenreRadioButton from "./genreradiobutton";

class SelectGenre extends Component {
  state = {
    genres: ["rock", "pop", "metal", "hip hop", "jazz", "electronic"],
  };

  render() {
    const { genres } = this.state;
    const { genre, setGenre, excluded } = this.props;

    return (
      <Grid container direction="row" justifyContent="center" spacing={2}>
        {genres
          .filter((e) => e !== excluded)
          .map((genreToDisplay, index) => {
            return (
              <Grid item xs={3}>
                <GenreRadioButton
                  genre={genreToDisplay}
                  isSelected={() => genreToDisplay === genre}
                  select={() => setGenre(genreToDisplay)}
                />
              </Grid>
            );
          })}
      </Grid>
    );
  }
}

export default SelectGenre;
